export default class Dispatcher {
  static run(app) {
    $(document).ready(() => {
      const action = $('html').data('action');
      if (app[action]) app[action]();
    });
  }
}
